export class FinancialYearApiModel {
    financialYearID: number;
    name: string;
    dateStart?: string;
    dateEnd?: string;
    dateClosed?: string;
}